import { LocationControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author rajkumar rathod
 */
export const useLocationArchive = () =>
  useMutationWithLoading(
    async (params: {
      locationId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new LocationControllerApi(getConfigObject()).updateLocationArchiveStatus(
        params?.locationId,
        params?.status,
        params?.xTENANTID
      )
  );
